// Search vars
const searchInput = document.querySelector(".search-input");
const searchSubmit = document.querySelector(".search-submit");
const searchResultsContainer = document.getElementById('search-results');
let selectedSearchId = '';
let debounceTimeout;

// State Code
const stateCode = document.getElementById('search-state-code') ? document.getElementById('search-state-code').value : null;
const isProd = document.getElementById('is-prod') ? document.getElementById('is-prod').value : null;

// Alpha nav vars
const stickyAlphas = document.querySelector(".locale-alphas");
const locales = document.querySelector(".bao-locale-list");
const localeLinks = document.querySelector(".locale-link");
const alphaTriggers = document.querySelectorAll("li.alpha");
let scrollbarWidth = window.innerWidth - document.body.clientWidth;
let currStickyPos = stickyAlphas.getBoundingClientRect().top + window.scrollY;
let maxScroll = window.innerWidth < 568 ? (locales.getBoundingClientRect().bottom - (stickyAlphas.clientHeight - 70)) : (locales.getBoundingClientRect().bottom - stickyAlphas.clientHeight);
let resizeTimeout;

// District accordion vars
let districtTriggers = document.querySelectorAll(".locale-link.is-district");
let schoolTriggers = document.querySelectorAll(".locale-school:not(.body)");
let schoolContents = schoolTriggers.nextElementSibling;
let schoolCtaButtons = document.querySelectorAll(".locale-school .block .cta .cta-button");

function toggleExpand(target) {
  if (target.classList.contains("is-district")) {
    districtTriggers.forEach(district => {    
      if (district !== target) {
        district.classList.remove("is-expanded");
        district.nextElementSibling.classList.remove("expanded");
      }
    });
    schoolTriggers.forEach(school => {
      school.classList.remove("is-expanded");
      school.nextElementSibling.classList.remove("expanded");
    });
  }
  if (target.classList.contains("locale-school")) {
    schoolTriggers.forEach(school => {
      if (school !== target) {
        school.classList.remove("is-expanded");
        school.nextElementSibling.classList.remove("expanded");
      }
    });
  }
  target.classList.add("is-expanded");
  target.classList.remove('loading');
  target.nextElementSibling.classList.add("expanded");
}


function isHalfScrolled(element) {
  const rect = element.getBoundingClientRect();
  return window.scrollY > (rect.top + rect.height / 2);
}

const getOffscreenOffset = (element) => {
  const rect = element.getBoundingClientRect();
  const bottomOffset = rect.height - window.innerHeight;
  return bottomOffset > 0 ? -bottomOffset : 0;
}

function adjustAlphaNavMidScroll() {
  const defaultTop = window.innerWidth < 568 ? "70px" : "0px";
  if (stickyAlphas.clientHeight > window.innerHeight) {
    if (isHalfScrolled(locales)) {
      return window.innerWidth < 568 ? `${getOffscreenOffset(stickyAlphas) + 70}px` : `${getOffscreenOffset(stickyAlphas)}px`;
    }
    return defaultTop
  }
  return defaultTop;
}

function calculateAlphaPositions() {
  if (window.scrollY > currStickyPos && window.scrollY < maxScroll) {
    stickyAlphas.style.position = "fixed";
    stickyAlphas.style.top = adjustAlphaNavMidScroll();
    stickyAlphas.style.right = (window.innerWidth - localeLinks.getBoundingClientRect().right - 50 - scrollbarWidth) + "px";
  } else if (window.scrollY >= maxScroll) {
    stickyAlphas.style.position = "absolute";
    stickyAlphas.style.top = "unset";
    stickyAlphas.style.bottom = "0px";
    stickyAlphas.style.right = "0px";
  } else {
    stickyAlphas.style.position = "absolute";
    stickyAlphas.style.top = "0px";
    stickyAlphas.style.right = "0px";
  }
}

// Set events
window.addEventListener("scroll", calculateAlphaPositions);
window.addEventListener("resize", () => {
  stickyAlphas.style.opacity = 0;
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    calculateAlphaPositions();
    stickyAlphas.style.opacity = 1;
  }, 100);
});

document.addEventListener('click', (e) => {
  if (searchResultsContainer.style.display !== "none" && !searchResultsContainer.contains(e.target)) {
    searchResultsContainer.style.display = "none";
  }
});

alphaTriggers?.forEach(alpha => {
  alpha.addEventListener("click", e => {
    e.preventDefault();
    const target = document.querySelector(`[data-first-letter="${alpha.innerText}"]`);
    window.scrollTo({
      top: target.getBoundingClientRect().top + window.scrollY - stickyAlphas.clientHeight,
      behavior: "smooth"
    });
    setTimeout(() => {
      target.focus();
      setTimeout(() => {
        target.blur();
      },2000);
    }, 300);
  });
});

const handleDistrictClick = (district, e) => {
  if ((e.type === 'keydown' && e.key === 'Enter') || e.type === 'click') {
    e.preventDefault();
    if (!('fetched' in e.target.dataset)) {
      if (e.target.dataset.districtId) {
        district.classList.add('loading');
        fetch(`/webservices_sw/rentals-schools/${e.target.dataset.districtId}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          }
        })
        .then(response => response.json())
        .then(data => {
          const schoolListContainer = document.getElementById(`district-${e.target.dataset.districtId}`).querySelector('.block');
          schoolListContainer.innerHTML = generateSchoolHTML(data);
          updateTriggers();
          toggleExpand(district);
          e.target.dataset.fetched = 1; 
          e.target.nextElementSibling.querySelector(".locale-school").focus();
        })
        .catch((error) => {
            console.error('Error:', error);
        });
      } else {
        console.error('No district ID was provided!');
      }
    } else {
      toggleExpand(district);
      e.target.nextElementSibling.querySelector(".locale-school").focus();
    }
  }
}

districtTriggers?.forEach(district => {
  district.addEventListener('keydown', (e) => handleDistrictClick(district, e));
  district.addEventListener('click', (e) => handleDistrictClick(district, e));
});

searchSubmit?.addEventListener("click", e => {
  e.preventDefault();
  return location.href = `https://${isProd ? 'www' : 'dev'}.sweetwater.com/instrument-rentals/rent/select-school/${selectedSearchId}`;
});

searchInput?.addEventListener("input", e => {
  searchSubmit.disabled = true;
  clearTimeout(debounceTimeout);
  debounceTimeout = setTimeout(() => {
    if (searchInput.value.length > 2 && stateCode !== "") {
      return search(searchInput.value);
    } else {
      searchResultsContainer.style.display = "none";
    }
  }, 500);
});

function search(searchTerm) {
      const progressBar = document.getElementById('search-progress');
      searchSubmit.disabled = true;
      selectedSearchId = '';
      progressBar.style.display = "block";

      if (searchTerm && stateCode) {
        fetch(`/webservices_sw/rentals-search/${searchTerm}/${stateCode}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            }
        })
        .then(response => response.json())
        .then(data => {
          searchResultsContainer.innerHTML = '';
          const filteredData = data.filter(item => item.id !== 0);

          if (filteredData.length > 0) {
            filteredData.forEach(item => {
              const itemDiv = document.createElement('div');
              itemDiv.classList.add('search-item');
        
              itemDiv.innerHTML = `
                <h4>${item.name}</h3>
                <p>${item.address1 ? item.address1 + ', ' + item.city : ''}</p>
              `;

              itemDiv.setAttribute('data-id', item.id);
              itemDiv.addEventListener('click', function() {
                  let siblings = this.parentElement.children;

                  for (let sibling of siblings) {
                    sibling.classList.remove('selected');
                  }

                  this.classList.add('selected');
                  searchInput.value = item.name;
                  selectedSearchId = this.getAttribute('data-id');
                  searchSubmit.disabled = false;
                  searchResultsContainer.style.display = "none";
              });
        
              searchResultsContainer.appendChild(itemDiv);
            });
          } else {
            const noResults = document.createElement('div');

            noResults.classList.add('search-no-results');
            noResults.innerHTML = `<p><strong>No results found!</strong><br/>You can still view all the <a href="https://${isProd ? 'www' : 'dev'}.sweetwater.com/instrument-rentals/rent/">instrument rental options</a> we have available!</p>`;

            searchResultsContainer.appendChild(noResults);
          }

          progressBar.style.display = "none";
          searchResultsContainer.style.display = "block";

        })
        .catch((error) => {
            console.error('Error:', error);
        });
    } else {
      progressBar.style.display = "none";
      console.error('No search term or state code provided!');
    }
};

function generateSchoolHTML(data) {
  return data.map(item => {
    return `
      <a href="#" class="locale-school" data-target="schoolExpand-${item.id}" tabindex="-1">
        <div class="school">
          <h3>${item.name} <span>${item.address1 ? item.address1 + ', ' : ''}${item.city}</span></h3>
        </div>
      </a>
      <div id="schoolExpand-${item.id}" class="locale-school body">
        <div class="block">
          <p class="main">
            Sweetwater is here to support students &amp; band directors!
          </p>
          <div class="cta">
            <a href="https://${isProd ? 'www' : 'dev'}.sweetwater.com/instrument-rentals/rent/select-school/${item.id}" class="cta-button" tabindex="-1">
              Rent for ${item.name}
            </a>
          </div>
        </div>
      </div>
    `;
  }).join('');
}

function updateTriggers() {
  schoolTriggers = document.querySelectorAll(".locale-school:not(.body)");
  schoolContents = schoolTriggers.nextElementSibling;
  schoolCtaButtons = document.querySelectorAll(".locale-school .block .cta .cta-button");

  schoolTriggers?.forEach(school => {
    school.addEventListener("click", e => {
      e.preventDefault();
      toggleExpand(school);
      school.nextElementSibling.querySelector(".cta-button").focus();
    });
    school.addEventListener("keydown", e => {
      if (e.key === "Tab" && !e.shiftKey) {
        e.preventDefault();
        if (e.target.nextElementSibling.nextElementSibling) {
          e.target.nextElementSibling.nextElementSibling.focus();
        } else {
          e.target.parentElement.parentElement.nextElementSibling.focus();
        }
      } else if(e.key === "Tab" && e.shiftKey) {
        e.preventDefault();
        if (e.target.previousElementSibling) {
          e.target.previousElementSibling.previousElementSibling.focus();
        } else {
          e.target.parentElement.parentElement.previousElementSibling.focus();
        }
      }
    });
  });
  
  schoolCtaButtons?.forEach(button => {
    button.addEventListener("keydown", e => {
      if (e.key === "Tab" && !e.shiftKey) {
        e.preventDefault();
        if (document.querySelector(`[data-target="${e.target.parentElement.parentElement.parentElement.id}"`).nextElementSibling?.nextElementSibling) {
          document.querySelector(`[data-target="${e.target.parentElement.parentElement.parentElement.id}"`).nextElementSibling?.nextElementSibling.focus();
        } else {
          e.target.parentElement.parentElement.parentElement.parentElement.parentElement.nextElementSibling?.focus();
        }
      } else if(e.key === "Tab" && e.shiftKey) {
        e.preventDefault();
        document.querySelector(`[data-target="${e.target.parentElement.parentElement.parentElement.id}"`).focus();
      }
    });
  });
}